export default __webpack_public_path__ + "static/media/homeSaibaMaisPeople.d30b99d2.png";